/* Sisters Moto: moved out of snippets/sm-garage.liquid so it is cached instead of repeated in every page. */
(function () {
  'use strict';

  var root = document.querySelector('[data-sm-garage]');
  if (!root || window.SmGarage) return;

  var STORE_KEY = 'smoto:garage';
  var PENDING_KEY = 'smoto:garage-pending';
  var MAX_VEHICLES = 6;
  // MotoFit's cookies: numeric IDs in year / make / model, labels in ymm_*.
  // If MotoFit ever renames these, this is the one line to update.
  var COOKIE_MATCH = /^(year|make|model)$|^ymm_/i;
  var COOKIE_DAYS = 30;

  var openers = Array.prototype.slice.call(root.querySelectorAll('[data-sm-garage-open]'));
  var trigger = root.querySelector('.sm-garage__trigger');      // header icon (may be absent)
  var tab = root.querySelector('.sm-garage-tab');               // side tab (may be absent)
  var countEls = Array.prototype.slice.call(root.querySelectorAll('[data-sm-garage-count]'));
  var liveEl = root.querySelector('[data-sm-garage-live]');
  var tabSide = root.getAttribute('data-tab-side') === 'left' ? 'left' : 'right';
  var lastOpener = null;
  var panel = root.querySelector('[data-sm-garage-panel]');
  var scrim = root.querySelector('[data-sm-garage-scrim]');
  var activeEl = panel.querySelector('[data-sm-garage-active]');
  var listEl = panel.querySelector('[data-sm-garage-list]');
  var emptyEl = panel.querySelector('[data-sm-garage-empty]');
  var noticeEl = panel.querySelector('[data-sm-garage-notice]');
  var addBtn = panel.querySelector('[data-sm-garage-add]');
  var formEl = panel.querySelector('[data-sm-garage-form]');

  // Portal the panel, scrim and tab to <body> so the header can't clip them
  document.body.appendChild(scrim);
  document.body.appendChild(panel);
  if (tab) document.body.appendChild(tab);

  /* ---------- helpers ---------- */

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function vehicleKey(v) {
    return String(v.year + ' ' + v.make + ' ' + v.model).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function load() {
    try {
      var list = JSON.parse(window.localStorage.getItem(STORE_KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (v) { return v && v.key && v.year && v.make && v.model; }) : [];
    } catch (e) { return []; }
  }

  function save(list) {
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify(list.slice(0, MAX_VEHICLES))); } catch (e) {}
    document.dispatchEvent(new CustomEvent('smoto:garage:updated'));
  }

  function readMotofitCookies() {
    var out = {};
    document.cookie.split(/;\s*/).forEach(function (pair) {
      var i = pair.indexOf('=');
      if (i < 1) return;
      var name = pair.slice(0, i);
      if (COOKIE_MATCH.test(name)) out[name] = pair.slice(i + 1);
    });
    return out;
  }

  function writeCookie(name, value, maxAge) {
    document.cookie = name + '=' + value + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function deleteMotofitCookies() {
    var host = window.location.hostname;
    Object.keys(readMotofitCookies()).forEach(function (name) {
      writeCookie(name, '', 0);
      // also clear any copy set on the parent domain
      document.cookie = name + '=; path=/; max-age=0; domain=.' + host.replace(/^www\./, '');
    });
  }

  function currentVehicle() {
    var v = window.motofitSelectedVehicle;
    if (!v || !v.year || !v.make || !v.model) return null;
    var f = window.applied_filters || {};
    var ok = function (x) { return x != null && x !== '' && String(x) !== 'null'; };
    return {
      year: String(v.year).trim(),
      make: String(v.make).trim(),
      model: String(v.model).trim(),
      ids: ok(f.year) && ok(f.make) && ok(f.model) ? { year: String(f.year), make: String(f.make), model: String(f.model) } : null
    };
  }

  function activeKey() {
    var v = currentVehicle();
    return v ? vehicleKey(v) : '';
  }

  function shopUrl(ids) {
    if (!ids) return '';
    var p = new URLSearchParams();
    p.set('type', 'filteredProducts');
    p.set('year', ids.year);
    p.set('make', ids.make);
    p.set('model', ids.model);
    p.set('page', '1');
    return '/apps/get-api-data?' + p.toString();
  }

  /* ---------- save the current MotoFit vehicle ---------- */

  function capture() {
    var v = currentVehicle();
    if (!v) return false;
    var key = vehicleKey(v);
    var list = load();
    var prev = null;
    list = list.filter(function (x) { if (x.key === key) { prev = x; return false; } return true; });
    var cookies = readMotofitCookies();
    list.unshift({
      key: key,
      year: v.year,
      make: v.make,
      model: v.model,
      ids: v.ids || (prev && prev.ids) || null,
      cookies: Object.keys(cookies).length ? cookies : (prev && prev.cookies) || null,
      lastUsed: Date.now()
    });
    save(list);
    render();
    return true;
  }

  /* ---------- render ---------- */

  function showNotice(text, success) {
    noticeEl.textContent = text;
    noticeEl.classList.toggle('is-success', !!success);
    noticeEl.hidden = !text;
  }

  function render() {
    var list = load();
    var current = activeKey();
    var active = null;

    var label = list.length ? 'My garage, ' + list.length + (list.length === 1 ? ' vehicle' : ' vehicles') : 'My garage';
    countEls.forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
    openers.forEach(function (el) { el.setAttribute('aria-label', label); });
    if (liveEl) liveEl.hidden = !current;

    listEl.innerHTML = list.map(function (v) {
      var isActive = v.key === current;
      if (isActive) active = v;
      return '<li class="sm-garage__row' + (isActive ? ' is-active' : '') + '" data-key="' + esc(v.key) + '">' +
        '<button type="button" class="sm-garage__switch" data-sm-garage-switch' + (isActive ? ' aria-current="true"' : '') + '>' +
          '<span class="sm-garage__year">' + esc(v.year) + '</span>' +
          '<span class="sm-garage__name">' + esc(v.make + ' ' + v.model) + '</span>' +
          '<span class="sm-garage__go">' + (isActive ? 'Shopping' : 'Switch') + '</span>' +
        '</button>' +
        '<button type="button" class="sm-garage__remove" data-sm-garage-remove aria-label="Remove ' + esc(v.year + ' ' + v.make + ' ' + v.model) + ' from garage">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>' +
        '</button>' +
      '</li>';
    }).join('');

    if (active) {
      var url = shopUrl(active.ids);
      var C = window.SmYmmConfig || {};
      var oem = C.oemFor ? C.oemFor(active) : null;
      var canShare = C.share && C.bikeLink && active.cookies && C.bikeLink(active.cookies);
      activeEl.innerHTML =
        '<p class="sm-garage__active-kicker">Shopping for</p>' +
        '<p class="sm-garage__active-name">' + esc(active.year + ' ' + active.make + ' ' + active.model) + '</p>' +
        '<div class="sm-garage__active-actions">' +
          (url ? '<a class="sm-garage__shop" href="' + esc(url) + '">Shop parts that fit</a>' : '') +
          (oem ? '<a class="sm-garage__shop sm-garage__shop--outline" href="' + esc(oem.url) + '" data-sm-oem-link>OEM parts diagrams</a>' : '') +
          '<button type="button" class="sm-garage__link-light" data-sm-garage-clear>Stop filtering by this bike</button>' +
          (canShare ? '<button type="button" class="sm-garage__link-light" data-sm-garage-share>Copy link to this bike</button>' : '') +
        '</div>';
      activeEl.hidden = false;
    } else {
      activeEl.innerHTML = '';
      activeEl.hidden = true;
    }

    emptyEl.hidden = list.length > 0;
    addBtn.hidden = list.length >= MAX_VEHICLES;
    if (list.length >= MAX_VEHICLES && !formEl.hidden) closeForm();
  }

  /* ---------- MotoFit selector inside the panel ---------- */

  var wrapperHome = null; // placeholder marking where #ymmInlineWrapper normally lives

  function openForm() {
    var wrapper = document.getElementById('ymmInlineWrapper');
    formEl.innerHTML = '';
    if (wrapper) {
      if (!wrapperHome) {
        wrapperHome = document.createComment('ymmInlineWrapper home');
        wrapper.parentNode.insertBefore(wrapperHome, wrapper);
      }
      formEl.appendChild(wrapper);
      formEl.hidden = false;
      addBtn.setAttribute('aria-expanded', 'true');
      var first = wrapper.querySelector('select, input, button');
      if (first) setTimeout(function () { first.focus(); }, 50);
    } else {
      formEl.innerHTML = '<span class="sm-garage__fallback">The vehicle selector isn\'t available on this page. Use Shop by Vehicle in the menu, and your bike will be saved here automatically.</span>';
      formEl.hidden = false;
      addBtn.setAttribute('aria-expanded', 'true');
    }
  }

  function closeForm() {
    var wrapper = formEl.querySelector('#ymmInlineWrapper');
    if (wrapper && wrapperHome && wrapperHome.parentNode) {
      wrapperHome.parentNode.insertBefore(wrapper, wrapperHome);
    }
    formEl.hidden = true;
    addBtn.setAttribute('aria-expanded', 'false');
  }

  /* ---------- panel ---------- */

  function place() {
    if (window.matchMedia('(max-width: 749px)').matches) return; // CSS bottom sheet
    if (panel.classList.contains('is-drawer') || !trigger) return; // CSS drawer
    var r = trigger.getBoundingClientRect();
    panel.style.top = Math.round(r.bottom + 8) + 'px';
    panel.style.right = Math.max(12, Math.round(window.innerWidth - r.right - 8)) + 'px';
    panel.style.left = 'auto';
  }

  function open(opts) {
    opts = opts || {};
    // Drawer when opened from the side tab, or when there's no header icon to anchor to
    var drawer = opts.mode === 'drawer' || !trigger;
    panel.classList.toggle('is-drawer', drawer);
    panel.classList.toggle('is-drawer--right', drawer && tabSide === 'right');
    panel.classList.toggle('is-drawer--left', drawer && tabSide === 'left');
    scrim.classList.toggle('is-drawer', drawer);
    lastOpener = opts.opener || (drawer ? tab : trigger) || null;
    render();
    place();
    panel.hidden = false;
    scrim.hidden = false;
    if (tab) tab.classList.add('is-hidden');
    openers.forEach(function (el) { el.setAttribute('aria-expanded', 'true'); });
    if (opts.addForm || !load().length) openForm();
    var focusTarget = opts.addForm ? null : panel.querySelector('[data-sm-garage-close]');
    if (focusTarget) focusTarget.focus();
  }

  function close() {
    if (panel.hidden) return;
    closeForm();
    showNotice('');
    panel.hidden = true;
    scrim.hidden = true;
    if (tab) tab.classList.remove('is-hidden');
    openers.forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
    if (lastOpener && lastOpener.offsetParent !== null) lastOpener.focus();
  }

  /* ---------- actions ---------- */

  function switchTo(key, row) {
    if (key === activeKey()) { close(); return; }
    var v = load().filter(function (x) { return x.key === key; })[0];
    if (!v) return;
    if (!v.cookies || !Object.keys(v.cookies).length) {
      showNotice('Pick your ' + v.year + ' ' + v.make + ' ' + v.model + ' once more below to finish saving it.');
      openForm();
      return;
    }
    if (row) row.classList.add('is-busy');
    deleteMotofitCookies();
    Object.keys(v.cookies).forEach(function (name) {
      writeCookie(name, v.cookies[name], COOKIE_DAYS * 86400);
    });
    try { window.sessionStorage.setItem(PENDING_KEY, key); } catch (e) {}
    window.location.reload();
  }

  function removeVehicle(key, row) {
    var wasActive = key === activeKey();
    save(load().filter(function (x) { return x.key !== key; }));
    if (wasActive) {
      if (row) row.classList.add('is-busy');
      deleteMotofitCookies();
      window.location.reload();
      return;
    }
    render();
  }

  // Copy a link that opens the site with the active bike selected (see snippets/sm-ymm-config.liquid)
  function shareActive(btn) {
    var key = activeKey();
    var v = load().filter(function (x) { return x.key === key; })[0];
    var C = window.SmYmmConfig || {};
    var link = v && v.cookies && C.bikeLink ? C.bikeLink(v.cookies) : '';
    if (!link) return;
    var done = function () {
      btn.textContent = 'Link copied';
      setTimeout(function () { btn.textContent = 'Copy link to this bike'; }, 2200);
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(link).then(done, function () { window.prompt('Copy this link:', link); });
    } else {
      window.prompt('Copy this link:', link);
    }
    if (window.SmYmmPlus) window.SmYmmPlus.track('sm_ymm_bike_link_copied', { vehicle: v.year + ' ' + v.make + ' ' + v.model });
  }

  function clearActive() {
    deleteMotofitCookies();
    window.location.reload();
  }

  /* ---------- events ---------- */

  openers.forEach(function (el) {
    el.addEventListener('click', function () {
      if (!panel.hidden) return close();
      open({ mode: el.getAttribute('data-sm-garage-open'), opener: el });
    });
  });
  scrim.addEventListener('click', close);
  panel.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-sm-garage-close]')) return close();
    if (t.closest('[data-sm-garage-add]')) return openForm();
    if (t.closest('[data-sm-garage-clear]')) return clearActive();
    var shareBtn = t.closest('[data-sm-garage-share]');
    if (shareBtn) return shareActive(shareBtn);
    var row = t.closest('.sm-garage__row');
    if (!row) return;
    if (t.closest('[data-sm-garage-remove]')) return removeVehicle(row.getAttribute('data-key'), row);
    if (t.closest('[data-sm-garage-switch]')) return switchTo(row.getAttribute('data-key'), row);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) close();
  });
  window.addEventListener('resize', function () { if (!panel.hidden) place(); });
  window.addEventListener('scroll', function () { if (!panel.hidden) place(); }, { passive: true });

  document.addEventListener('motofit:ymm:updated', function () {
    // MotoFit may write its cookies right after firing the event
    var had = activeKey();
    setTimeout(function () {
      if (capture() && !panel.hidden && !formEl.hidden) {
        closeForm();
        showNotice('Saved to your garage.', true);
      } else if (!had) {
        render();
      }
    }, 150);
  });

  // Other tabs
  window.addEventListener('storage', function (e) { if (e.key === STORE_KEY) render(); });

  /* ---------- start-up ---------- */

  var pending = null;
  try {
    pending = window.sessionStorage.getItem(PENDING_KEY);
    window.sessionStorage.removeItem(PENDING_KEY);
  } catch (e) {}

  render();

  // MotoFit initialises on window load; wait for its vehicle, up to ~10s
  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    var ready = !!currentVehicle();
    if (ready) capture();
    // after a switch, don't make the customer wait long to hear it failed
    if (ready || tries > (pending ? 8 : 20)) {
      clearInterval(poll);
      if (pending && activeKey() !== pending) {
        var target = load().filter(function (x) { return x.key === pending; })[0];
        var name = target ? target.year + ' ' + target.make + ' ' + target.model : 'that bike';
        console.warn('[garage] switch did not take: MotoFit reports', window.motofitSelectedVehicle, 'expected', pending);
        open({ addForm: true });
        showNotice('We couldn\'t switch to your ' + name + '. Pick it again below and it will stay saved.');
      }
      render();
    }
  }, 500);

  window.SmGarage = {
    list: load,
    activeKey: activeKey,
    open: open,
    key: vehicleKey
  };
})();
